import { useCallback, useEffect, useState } from "react";
import { MessageModalProps } from "../components/MessageModal";

type UseRestartErrorModalResult = {
  messageModal: MessageModalProps;
  setMessageModal: React.Dispatch<React.SetStateAction<MessageModalProps>>;
  openMessageModal: (title?: string) => void;
  closeMessageModal: () => void;
  scheduleRestartErrorMessage: () => void;
};

export function useRestartErrorModal(defaultTitle: string): UseRestartErrorModalResult {
  const [messageModal, setMessageModal] = useState<MessageModalProps>({
    isOpen: false,
    buttons: [],
    title: defaultTitle,
    isErrorAck: true,
  });
  const [isRestartErrorMessage, setIsRestartErrorMessage] = useState(false);

  const openMessageModal = useCallback((title?: string) => {
    setMessageModal((prev) => ({
      ...prev,
      title: title || defaultTitle,
      isOpen: true,
    }));
  }, [defaultTitle]);

  const closeMessageModal = useCallback(() => {
    setMessageModal((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, []);

  const scheduleRestartErrorMessage = useCallback(() => {
    setIsRestartErrorMessage(true);
  }, []);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    // 保留原来的“两分钟后再次弹错误框”行为，只是把定时器从 App.tsx 挪出来。
    if (isRestartErrorMessage) {
      timer = setTimeout(() => {
        openMessageModal(defaultTitle);
        setIsRestartErrorMessage(false);
      }, 60 * 1000 * 2);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [defaultTitle, isRestartErrorMessage, openMessageModal]);

  return {
    messageModal,
    setMessageModal,
    openMessageModal,
    closeMessageModal,
    scheduleRestartErrorMessage,
  };
}
